import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import { ProducerDto } from '../../../core/data/dtos/producer.dto';

@Injectable({ providedIn: 'root' })
export class ProducersService extends BaseCrudService<ProducerDto> {
  controller = 'Producers';

  getProducers(slob?: number): Observable<ProducerDto[]> {
    return this.get<ProducerDto[]>(slob ? { Slob: slob } : undefined);
  }
}
